module.exports = __webpack_public_path__ + "img/a2972f4.png";